// GENERATED by bam-api-services/scripts/sync-tenants.js — DO NOT EDIT.
// Source of truth: bam-api-services/src/constants/tenants.json
//
// Keyed by admin host: this file is read only by bam-frontend, which is served
// only on the DAM distribution. Tenant primary domains serve mp, so entries for
// them could never be consulted.

export const coBrandConfig = {
  "admin-anaconda.bam.zone": {
    favicon: "/anaconda-icon.png",
    tabTitle: "BAM! Anaconda Equipment",
    className: "anaconda"
  },
  "admin-arrowheadwinch.bam.zone": {
    favicon: "/arrowheadwinch-icon.png",
    tabTitle: "BAM! Arrowhead Winch",
    className: "arrowheadwinch"
  },
  "admin-avanttecno.bam.zone": {
    favicon: "/avanttecno-icon.png",
    tabTitle: "BAM! Avant Tecno",
    className: "avanttecno"
  },
  "admin-btahelp.bam.zone": {
    favicon: "/btahelp-icon.png",
    tabTitle: "BAM! Bell Trucks America",
    className: "bta"
  },
  "admin-develon.bam.zone": {
    favicon: "/develon-icon.png",
    tabTitle: "BAM! DEVELON",
    className: "develon"
  },
  "admin-diefenbach.bam.zone": {
    favicon: "/diefenbach-icon.png",
    tabTitle: "BAM! Diefenbach",
    className: "diefenbach"
  },
  "admin-eagleironworks.bam.zone": {
    favicon: "/eagleironworks-icon.png",
    tabTitle: "BAM! Eagle Iron Works",
    className: "eagleironworks"
  },
  "admin-fennerdunlop.bam.zone": {
    favicon: "/fennerdunlop-icon.png",
    tabTitle: "BAM! Fenner Dunlop",
    className: "fennerdunlop",
    registrationLink: "none"
  },
  "admin-finn.bam.zone": {
    favicon: "/finn-icon.jpg",
    tabTitle: "BAM! FINN",
    className: "finn"
  },
  "admin-frain.bam.zone": {
    favicon: "/frain-icon.png",
    tabTitle: "BAM! Frain",
    className: "frain"
  },
  "admin-gefran.bam.zone": {
    favicon: "/gefran-icon.png",
    tabTitle: "BAM! Gefran",
    className: "gefran"
  },
  "admin-hcea.bam.zone": {
    favicon: "/hcea-icon.png",
    tabTitle: "BAM! HNA Dealer Sales",
    className: "hcea"
  },
  "admin-jls.bam.zone": {
    favicon: "/jls-icon.png",
    tabTitle: "BAM! JLS Automation",
    className: "jls",
    registrationLink: "none",
    privacyPolicy: "https://www.jlsautomation.com/privacy",
    termsAndConditions: "https://www.jlsautomation.com/terms"
  },
  "admin-labot.bam.zone": {
    favicon: "/labot-icon.png",
    tabTitle: "BAM! Young-chang Robotech",
    className: "labot"
  },
  "admin-mclanahan.bam.zone": {
    favicon: "/mclanahan-icon.png",
    tabTitle: "BAM! McLanahan",
    className: "mclanahan"
  },
  "admin-promach.bam.zone": {
    favicon: "/promach.ico",
    tabTitle: "BAM! ProMach",
    className: "promach",
    registrationLinkText: "Request one here",
    registrationLink: "https://go.wexxar.com/l/957132/2026-03-25/kg41x",
    privacyPolicy: "https://www.promachbuilt.com/privacy/",
    termsAndConditions: "https://www.promachbuilt.com/terms-and-conditions/"
  },
  "admin-rubblecrusher.bam.zone": {
    favicon: "/rubblecrusher-icon.png",
    tabTitle: "BAM! RubbleCrusher",
    className: "rubblecrusher"
  },
  "admin-sato.bam.zone": {
    favicon: "/sato-icon.png",
    tabTitle: "BAM! SATO America",
    className: "sato"
  },
  "admin-titan.bam.zone": {
    favicon: "/titan.ico",
    tabTitle: "BAM! Titan",
    className: "titan"
  },
  "admin-viably.bam.zone": {
    favicon: "/viably-icon.png",
    tabTitle: "BAM! Viably",
    className: "viably"
  }
}
